export default "__VITE_ASSET__ec03b445__"